import React, { Component } from 'react';
import loginFirebaseApp from '../functions/features/login-firebase-app';
// import { PAGETYPE } from '../../functions/helpers/constants';
import 'bootstrap/dist/css/bootstrap.min.css';
import angleslogo from '../images/logo.png';
import chromeimg from '../images/aaa.png';

import sabestianImg from '../images/agenda/Sebastian.png';
import mattImg from '../images/agenda/Matt.png';
import mohamedImg from '../images/agenda/Mohamed.png';
import nabilImg from '../images/agenda/Nabil.png';
import naifImg from '../images/agenda/Naif.png';
import ramiImg from '../images/agenda/Rami.png';
import tatjanaImg from '../images/agenda/Tatjana.png';

// import '../../../css/animate.css';
// import '../../../css/bootstrap.min.css';
// import '../../../css/devices.min.css';
// import '../../../css/font-awesome.min.css';
// import '../../../css/idangerous.swiper.css';
import './login-page.css';
// import { commonFunction } from '../../functions/helpers/analytics-function';

const axios = require('axios');
const expoName = 'merz';
const host = "https://merzanatomyworkshop.com/";
export default class LoginPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loginEmail: '',
            loginPassword: '',
        }
        this.loginButton = this.loginButton.bind(this);
        this.authCheck = this.authCheck.bind(this);
        this.getUserDetails = this.getUserDetails.bind(this);
        this.handleEmailKeyPress = this.handleEmailKeyPress.bind(this);
        this.handlePasswordKeyPress = this.handlePasswordKeyPress.bind(this);
        this.handleLoginEmailChange = this.handleLoginEmailChange.bind(this);
        this.handleLoginPasswordChange = this.handleLoginPasswordChange.bind(this);
        // this.initializeWow = this.initializeWow.bind(this);
    }

    // initializeWow() {
    //     var wow = new WOW({
    //         boxClass: 'wow', // animated element css class (default is wow)
    //         animateClass: 'animated', // animation css class (default is animated)
    //         offset: 100, // distance to the element when triggering the animation (default is 0)
    //         mobile: true, // trigger animations on mobile devices (default is true)
    //         live: true, // act on asynchronously loaded content (default is true)
    //         callback: function (box) {
    //             // the callback is fired every time an animation is started
    //             // the argument that is passed in is the DOM node being animated
    //         }
    //     });

    //     wow.init();
    // }

    // componentDidMount() {
    //     authFirebaseApp.auth().onAuthStateChanged((user) => {
    //         if (user) {
    //             console.warn('user is ',user)
    //             if(localStorage.getItem('userRole') === 'speaker'){
    //                 window.location.href = '/speaker-webinar'
    //             }
    //             else if(localStorage.getItem('userRole') === 'moderator'){
    //                 window.location.href = '/moderator-webinar'
    //             }else if(localStorage.getItem('userRole')==='user'){
    //                 window.location.href = "/entrance"
    //             }
    //             else{
    //                 window.location.href = '/entrance'
    //             }
    //           // User is signed in, see docs for a list of available properties
    //           // https://firebase.google.com/docs/reference/js/firebase.User
    //           var uid = user.uid;
    //           // ...
    //         } 
    //         else {
    //             console.warn('user not found')
    //           // User is signed out
    //           // ...
    //         }
    //       });
    // }


    componentDidMount() {
        if (localStorage.getItem('userRole') === 'user' && localStorage.getItem('uid') !== '') {
            window.location.href = '/archive'
        } else if (localStorage.getItem('userRole') === 'speaker' && localStorage.getItem('uid') !== '') {
            window.location.href = '/speaker-webinar'
        } else if (localStorage.getItem('userRole') === 'moderator' && localStorage.getItem('uid') !== '') {
            window.location.href = '/moderator-webinar'
        }

    }

    loginButton(e) {
        e.preventDefault();
        var patternEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
        if (this.state.loginEmail === '') {
            alert('Please enter Email Id');
        } else if (!patternEmail.test(this.state.loginEmail)) {
            alert('Please enter valid Email Id');
        } else {
            document.getElementById('loader-login').style.display = 'block';
            document.getElementById('login-name').style.display = 'none';
            this.authCheck();
        }
    }

    handleEmailKeyPress(e) {
        e = e || window.event;
        if (e.keyCode === 13) {
            document.getElementById('login-password-txt').focus();
        }
    }

    handlePasswordKeyPress(e) {
        e = e || window.event;
        if (e.keyCode === 13) {
            document.getElementById('login-btn').click();
        }
    }

    handleLoginEmailChange(e) {
        e.preventDefault();
        this.setState({ loginEmail: e.target.value })
    }

    handleLoginPasswordChange(e) {
        e.preventDefault();
        this.setState({ loginPassword: e.target.value })
    }

    authCheck() {
        let loginEmailId = this.state.loginEmail.toLowerCase();
        const loginPassword = this.state.loginPassword;
        loginEmailId = loginEmailId.replace(/ /g, "");
        loginEmailId = loginEmailId.toLowerCase();
        // let loginData = new Promise((resolve, reject) => {
        //     authFirebaseApp.auth().signInWithEmailAndPassword(loginEmailId, loginPassword)
        //         .then(function (user) {
        //             resolve(user);
        //         }).catch(function (error) {
        //             // Handle Errors here.

        //             reject(error)
        //             // ...
        //         });

        // });
        // loginData.then(result => {
        //     console.warn('login Successful')
        //     // checkForExistingUserforLogin(loginEmailId)

        // }).catch(error => {
        //     console.error(error)
        //     var errorMessage = error.message;
        //     alert(errorMessage)
        // })
        this.getUserDetails(loginEmailId, loginPassword);
    }

    getUserDetails(emailId, secretKey) {
        const db = loginFirebaseApp.firestore();
        const userCollection = db.collection('Users');
        let ExistingUserQuery = new Promise((resolve, reject) => {
            userCollection.where('expo', '==', expoName).where('email', '==', emailId)
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        // console.log(doc.id, " => ", doc.data());
                        let myData = doc.data();
                        myData.id = doc.id;
                        resolve(myData);
                    });
                    resolve('Not Found');
                })
                .catch(function (error) {
                    reject(error);
                });
        });
        ExistingUserQuery.then(result => {
            if (result === 'Not Found') {
                alert('User details not found');
                document.getElementById('login-btn').removeAttribute('disabled');

                document.getElementById('loader-login').style.display = 'none';
                document.getElementById('login-name').style.display = 'block';
            } else {
                // commonFunction(PAGETYPE.LOBBY);

                document.getElementById('loader-login').style.display = 'none';
                document.getElementById('login-name').style.display = 'block';
                if (result.email === emailId && result.secretKey === secretKey) {
                    localStorage.setItem('name', result.name);
                    // localStorage.setItem('userId', result.id);
                    localStorage.setItem('country', result.country);
                    localStorage.setItem('uid', result.uid);
                    localStorage.setItem('userId', result.id);
                    localStorage.setItem('email', result.email);
                    localStorage.setItem('mobile', result.mobileNumber);
                    localStorage.setItem('designation', result.designation);
                    localStorage.setItem('speciality', result.speciality);
                    localStorage.setItem('roomName', 'archiveGallery');
                    if (result.userRole) {
                        localStorage.setItem('userRole', result.userRole);
                    }
                    else {
                        localStorage.setItem('userRole', 'user');
                    }
                    if (result) {
                        console.warn('user is ', result)
                        if (localStorage.getItem('userRole') === 'speaker') {
                            window.location.href = '/speaker-webinar'
                        }
                        else if (localStorage.getItem('userRole') === 'moderator') {
                            window.location.href = '/moderator-webinar'
                        } else if (localStorage.getItem('userRole') === 'user') {
                            window.location.href = "/archive"
                        }
                        else {
                            window.location.href = '/archive'
                        }
                        // User is signed in, see docs for a list of available properties
                        // https://firebase.google.com/docs/reference/js/firebase.User
                        // ...
                    }
                    else {
                        console.warn('user not found')
                        document.getElementById('loader-login').style.display = 'none';
                        document.getElementById('login-name').style.display = 'block';
                        alert('User data not found');
                        // User is signed out
                        // ...
                    }

                } else {
                    document.getElementById('loader-login').style.display = 'none';
                    document.getElementById('login-name').style.display = 'block';
                    alert('Your password is incorrect. Please enter your registered email/password combination');
                }
            }
        }).catch(error => {
            document.getElementById('loader-login').style.display = 'none';
            document.getElementById('login-name').style.display = 'block';
            console.error('Already existing user check error', error);
        });
    }
    goToAgenda = () => {
        document.getElementById('location1').style.display = 'block'
    }
    closePopup = () => {
        document.getElementById('location1').style.display = 'none'
    }

    changeTab = (tabNum) => {
        if (document.getElementById('tab-1').classList.contains('tab-current')) {
            document.getElementById('tab-1').classList.remove('tab-current');
            document.getElementById('tabHeader1').classList.remove('tab-active');
        }

        if (document.getElementById('tab-2').classList.contains('tab-current')) {
            document.getElementById('tab-2').classList.remove('tab-current');
            document.getElementById('tabHeader2').classList.remove('tab-active');
        }
        document.getElementById(`tab-${tabNum}`).classList.add('tab-current');
        document.getElementById(`tabHeader${tabNum}`).classList.add('tab-active');
    }

    forgotPassword = () => {

        const emailAddress = this.state.loginEmail.toLowerCase();
        const patternEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
        if (emailAddress === '') {
            alert('Please enter email id to send reset link')
        } else if (!patternEmail.test(emailAddress)) {
            alert('Please enter valid email id to send reset link');
        } else {
            document.getElementById('forgotPasswordLoader').style.display = 'flex';
            this.sendEmailForForgotPassword(emailAddress);
        }
    }

    makeToken = () => {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < 16; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }


    sendEmailForForgotPassword = (email) => {

        let registerData = new Promise((resolve, reject) => {
            const db = loginFirebaseApp.firestore();
            db.collection("Users").where("email", "==", email).where("expo", "==", expoName)
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());
                        resolve(doc.data());
                    });
                    resolve('Not Found')
                })
                .catch(function (error) {
                    console.log("Error getting documents: ", error);
                    reject(error)
                });


        });
        registerData.then(result => {
            if (result === 'Not Found') {
                alert('Looks like you are not registered yet. Please register first');
                document.getElementById('forgotPasswordLoader').style.display = 'none';
                setTimeout(() => {
                    window.location.href = host;
                }, 10000);
            } else {
                const token = this.makeToken();
                let registerQuery = new Promise((resolve, reject) => {

                    const db = loginFirebaseApp.firestore();
                    db.collection("PasswordResetLinks").add({
                        email: email,
                        host: host,
                        token: token,
                        expo: expoName
                    })
                        .then(function (docRef) {
                            console.log("Document written with ID: ", docRef.id);
                            resolve(docRef.id);
                        })
                        .catch(function (error) {
                            console.error("Error adding document: ", error);
                            reject(error);
                        });
                });
                registerQuery.then(res => {
                    console.warn('forgotPassword', result)

                    if (email !== '') {
                        const regMessage = `Dear Dr./Prof. ${result.name}, <br/><br/>` +
                            `<p> We have received your forgot password request.</p><p>Please click on below link to reset your password.</p>
                    <br/>
                    <a href='${host}reset.html#${token}'>RESET PASSWORD<a/>
                    <br/>
                    <br/>
                    <p>Thank you once again and have a wonderful day! </p>
                    <br/>
                    <b>If you have any queries please reply to this mail.</b>
                    <br/>
                    <p>Thank you,</p>
                    <br/>
                    <p>Merz Aesthtics Anatomy E-workshop</p>
                    <br/>
                    <img src="https://pptvr-images.s3.ap-south-1.amazonaws.com/image/public/image2d/merz/merz-logo.jpeg" alt="Merz Logo" style="height: 40px">
                    <br/>
                    <p  style="font-size: 10px;">Disclaimer : Please note that if you submit information to Merz all materials submitted by electronic or physical communication will be deemed non confidential. Do not submit any information or other materials that you consider to be confidential or proprietary. While we have no intention to publicly disclose any details of your proposal, we may refer to select experts within or outside the Merz network for evaluation.</p>
                    <br/>
                    
                    <br/>`;
                        var obj = {
                            useremail: email,
                            message: regMessage,
                            SiteType: expoName,
                            subject: 'Reset password link for your Merz Aesthetics Anatomy E-workshop'
                        };
                        //http://localhost:5000/sendtoemail-3610d/us-central1/expoRegistration
                        axios.post('https://us-central1-sendtoemail-3610d.cloudfunctions.net/anglesSendemail', obj, {
                            headers: { // 'x-access-token': token
                            }
                        }).then(function () {
                            console.log("Done", email)
                            // window.location.href = host + "reset.html";
                            // window.open('reset.html')

                        }).catch(error => {
                            console.log("Not Done", error);
                            document.getElementById('forgotPasswordLoader').style.display = 'none';
                            alert("Could not send password reset email");
                        });
                    } else {
                        document.getElementById('forgotPasswordLoader').style.display = 'none';
                        alert('Please enter your email')
                    }
                }).catch(error => {
                    console.error(error)
                })
            }

        }).catch(error => {
            console.error(error)
        })
    }

    goToRegistrationPage = () => {
        window.open("https://merzanatomyworkshop.com/")
    }

    render() {
        return (
            <div>
                <div className="logoposition">
                    <img src={angleslogo} className="widthangleslogo" alt="" />
                </div>
                <div id="content-wrapper">
                    <div className="blocks-container">
                        <div className="block type-1 scroll-to-block" data-id="register">
                            <div className="clip">
                                <div className="bg">
                                </div>
                                <div className="bg-span"></div>
                            </div>
                            <div className="container type-1-text wow flipInX " data-wow-delay="0.3s">
                                <div className="row">
                                    <div className="col-md-12 col-lg-8 col-12  type-1-center" style={{ textAlign: "left" }}>
                                        <div className="big white table margintopsection">
                                            <h1 className="h2 marginbottomzero">Merz Aesthetics Anatomy 2021</h1>

                                            <div style={{ color: "white", fontSize: "1.7rem" }}>On
                                            9<sup style={{ textTransform: "lowercase" }}>th</sup> & 10<sup style={{ textTransform: "lowercase" }}>th</sup>
                                            April 2021</div><br />
                                            <p className="marginbottomtext paddingbottomzero"><span className="registertext" style={{ cursor: 'pointer' }} onClick={this.goToRegistrationPage}>Register now</span> to get
                                                access to a
                                                one of its kind virtual
                                                event, with a line-up of
                                                highly informative sessions and expert speakers!
                                            </p>
                                            <button className="registerbutton" style={{ marginBottom: "40px", border: 0, outline: 0 }}
                                                onClick={this.goToAgenda}>
                                                Event Agenda
                                                </button>

                                        </div>


                                    </div>

                                    <div id="registration-form" style={{ display: 'block' }}
                                        className="col-md-8 col-lg-4 col-12 type-1-center">
                                        <div className="flexform margintoplogin">
                                            <div className="flex--form">
                                                <div>
                                                    <h5 className="color-green">LOGIN</h5>
                                                    <input className="required inputclass" id="login-email-txt" style={{ width: "100%" }} value={this.state.loginEmail}
                                                        onChange={this.handleLoginEmailChange} onKeyUp={this.handleEmailKeyPress} type="email" placeholder="*Your email" name="email" />
                                                    <input className="required inputclass" id="login-password-txt" autoComplete='false' value={this.state.loginPassword}
                                                        style={{ width: "100%" }} onKeyUp={this.handlePasswordKeyPress} onChange={this.handleLoginPasswordChange} type="password" placeholder="*Password"
                                                        name="password" />
                                                    <div onClick={this.forgotPassword} className="fontweight color-green margintopbottom" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        Forgot password?
                                                        <div className="loaderBtn" id="forgotPasswordLoader" style={{ display: 'none' }}></div>
                                                    </div>

                                                    <div className="submit-wraper" style={{ marginTop: "10px" }}>
                                                        <button className="registerbutton" style={{ marginBottom: "20px", outline: 0 }}
                                                            id="login-btn" onClick={(event) => this.loginButton(event)}>
                                                            <div id="login-name" style={{ display: 'block' }}>Login</div>
                                                            <div className="loaderBtn" id="loader-login" style={{ display: 'none' }}></div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <p className="marginbottomtext paddingbottomzero margintoplogin" style={{ fontSize: '12px' }} >
                                            Please note that if you submit information to Merz all materials submitted by electronic
                                            or physical communication will be deemed non confidential. Do not submit any information
                                            or other materials that you consider to be confidential or proprietary. While we have no
                                            intention to publicly disclose any details of your proposal, we may refer to select
                  experts within or outside the Merz network for evaluation.<br />
                  By registering on this
                  website, you agree to receive emails from us.
                </p>

                                    </div>
                                    <div class="col-12 col-md-4 col-lg-4" style={{ alignSelf: 'center' }}>
                                        <p class="paddingbottomzero footer_text">Use any of these browsers for best
                  experience!</p>
                                        <img src={chromeimg} alt="" className="chromewidth" />

                                    </div>
                                    <div class="col-12 col-md-4 col-lg-4">

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* AGENDA POPUP */}
                <div className="modal" id="location1" style={{ display: 'none' }}>
                    <div className="modal-dialog modal-dialog-centered modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title green-text" id="staticBackdropLabel">Agenda</h5>

                                <button type="button" className="close white-color" data-dismiss="modal" onClick={this.closePopup}>x</button>
                            </div>
                            {/* <!-- Agenda section --> */}
                            <section id="agenda">
                                <div className="container">
                                    <div className="schedule-tab">
                                        <a id="tabHeader1" className="schedule-tab__item tab-active leftborder" data-tab="tab-1" href="#tab-1" onClick={() => this.changeTab(1)}>
                                            <h2>Day <span>01</span></h2>
                                            <p>April 9, 2021</p>
                                        </a>
                                        <a id="tabHeader2" className="schedule-tab__item  rigthradius" data-tab="tab-2" href="#tab-2" onClick={() => this.changeTab(2)}>
                                            <h2>Day <span>02</span> </h2>
                                            <p>April 10, 2021</p>
                                        </a>

                                    </div>

                                    <div id="tab-1" className="schedule-table tab-current">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12">
                                                            <h4 className="remfont">
                                                                Session 1 :
                                                                Forehead fillers
                                                             </h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">16:00-17:10 </div>

                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the forehead </p>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live filler injection technique </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={ramiImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Rami Haidar </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Tackling the potential complications of HA fillers </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12">
                                                            <h4 className="remfont">
                                                                Session 2 :
                                                                            Temple fillers </h4>
                                                        </div>
                                                    </div>

                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">17:20-18:30</div>
                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the Temples</p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live filler injection technique </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={nabilImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Nabil Fakih </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Deep versus superficial temples filler injections - A
                                                                                    debate </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="schedule-listing">
                                                    <div className="schedule-item">
                                                        <div className="sc-time">18:30-18:40</div>
                                                        <div className="sc-pic">
                                                        </div>
                                                        <div className="sc-name">
                                                        </div>
                                                        <div className="sc-info">
                                                            <h3 >Q&A</h3>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>

                                                <div className="schedule-listing">
                                                    <div className="schedule-item">
                                                        <div className="sc-time">18:40- 19:10</div>
                                                        <div className="sc-pic">
                                                        </div>
                                                        <div className="sc-name">
                                                        </div>
                                                        <div className="sc-info">
                                                            <h3 >Break </h3>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12">
                                                            <h4 className="remfont">
                                                                Session 3 :
                                                                                        Undereye and Midface </h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">19:10-20:20 </div>
                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the under-eye and upper cheeks </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live filler injection technique </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={mohamedImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Mohammed G. Turkmani</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Using filler to fix different tear trough deformities
                                                                                                </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12">
                                                            <h4 className="remfont">
                                                                Session 4 : Lip Fillers </h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">20:20-21:30 </div>
                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the lips </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live filler injection technique </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={naifImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4> Dr. Naif Al Nomair</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Tips for lips
                                                                                                            </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div id="tab-2" className="schedule-table">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12 marginbottomzero">
                                                            <h4 className="remfont"> Session 1 :
                                                            Individualized approach to
                                                            relax facial
                                                            mimic
                                                            hyperactivity & keep natural appearance with one and
                                                                                                            only pure BoNTA</h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">16:00-17:10</div>
                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the facial muscles</p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={tatjanaImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Tatjana Pavicic</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Toxin injection technique
                                                                                                                    <br />Details as per indication followed by longevity and safety aspects

                                                                                                                    </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12 marginbottomzero">
                                                            <h4 className="remfont"> Session 2 : Jawline and
                                                                                                                            Chin</h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">17:10-18:20 </div>
                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the Jaw and Chin</p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live filler injection technique</p>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={ramiImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Rami Haidar </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Using CaHA in the Jawline and Chin </p>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>


                                                <div className="schedule-listing">
                                                    <div className="schedule-item">
                                                        <div className="sc-time">18:20-18:40</div>
                                                        <div className="sc-pic">
                                                        </div>
                                                        <div className="sc-name">

                                                        </div>
                                                        <div className="sc-info">
                                                            <h3>Q&amp;A</h3>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>


                                                </div>

                                                <div className="schedule-listing">
                                                    <div className="schedule-item">
                                                        <div className="sc-time">18:40-19:10 </div>
                                                        <div className="sc-pic">
                                                        </div>
                                                        <div className="sc-name">

                                                        </div>
                                                        <div className="sc-info">
                                                            <h3>Break</h3>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>


                                                <div class="schedule-listing">
                                                    <div class="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div class="col-12 col-md-12 col-lg-12 marginbottomzero">
                                                            <h4 class="remfont"> Session 3 : Hybrid Filler
                                                            for Facial
                                                            Prolifiting
                                                        </h4>
                                                        </div>
                                                    </div>
                                                    <div class="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div class="sc-time">19:10-20:20 </div>

                                                        <div class="combined-container">
                                                            <div class="sc-pic">
                                                                <img src={sabestianImg} class="img-circle"
                                                                    alt="" />
                                                            </div>
                                                            <div class="sc-name">
                                                                <h4>Prof. Sebastian Cotofana </h4>
                                                            </div>

                                                            <div class="sc-pic">
                                                                <img src={nabilImg} class="img-circle"
                                                                    alt="" />
                                                            </div>
                                                            <div class="sc-name">
                                                                <h4>Dr. Nabil Fakih </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="schedule-item">
                                                        <div class="sc-time paddingzero"></div>

                                                        <div class="sc-pic">
                                                        </div>
                                                        <div class="sc-name">
                                                        </div>
                                                        <div class="sc-info">
                                                            <p style={{ display: 'none' }}>Newest data on CaHA and HA Rheology </p>
                                                            <p>Combining CaHA and HA: a practical experience </p>

                                                        </div>
                                                        <div class="clearfix"></div>
                                                    </div>

                                                </div>

                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12 marginbottomzero">
                                                            <h4 className="remfont"> Session 4 : Nose filler
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">20:20-21:30 </div>

                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the nose </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live injection of fillers to enhance nose bridge </p>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={nabilImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Nabil Fakih </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Up-to-date scientific data on the different ways of using
                                                            fillers in nose </p>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                </div>


                            </section>
                        </div>
                    </div>
                </div>
                {/* AGENDA POPUP */}



            </div>
        )
    }
}
